import React from "react";
import MaterialTable from "material-table";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomInputForm from "components/CustomInput/CustomInputForm";
import Button from "components/CustomButtons/Button";
import MenuItem from "@material-ui/core/MenuItem";
import { Formik, Form } from "formik";
import useContract from "hooks/useContract";
import useMessage from "hooks/useMessage";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ButtonIcon from "@material-ui/icons/Description";
import PaymentIcon from "@material-ui/icons/AttachMoney";
import Tooltip from "@material-ui/core/Tooltip";
import validationSchema from "schema/schemaConfirmContract";

const useStyles = makeStyles(theme => ({
  formContainer: {
    marginTop: theme.spacing(2)
  },
  tableContainer: {
    marginTop: theme.spacing(4)
  }
}));

export default function ConfirmacionContrato() {
  const classes = useStyles();

  const renderActionButton = (rowData, handleConfirmContract) => {
    const { DESCRIPCION, ID_CONTRATO } = rowData;

    return (
      <div style={{ display: "flex", gap: 4 }}>
        {/* Confirmar manualmente — solo para pendientes, uso administrativo */}
        {DESCRIPCION === "pendiente" && (
          <Tooltip title="Confirmar manualmente (uso administrativo)">
            <IconButton
              color="default"
              size="small"
              onClick={() => {
                if (window.confirm("¿Confirmar este contrato manualmente? Normalmente la confirmación ocurre al cobrar el enganche desde Cobranza.")) {
                  handleConfirmContract(rowData);
                }
              }}
            >
              <ButtonIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {/* Ir a Cobranza — para cualquier contrato activo o pendiente */}
        {(DESCRIPCION === "pendiente" || DESCRIPCION === "creditoActivo") && (
          <Tooltip title="Ir a Cobranza">
            <IconButton
              color="primary"
              size="small"
              onClick={() => { window.location.href = "/admin/Cobranza?contrato=" + ID_CONTRATO; }}
            >
              <PaymentIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );
  };
  const {
    opensnack,
    typesnackbar,
    message,
    handleMuestraSnack,
    handleClosesSnack
  } = useMessage();

  const { column, contracts, handleSearchContract } = useContract({
    handleMuestraSnack,
    renderActionButton
  });

  return (
    <>
      <SnackBarWiiba
        opensnack={opensnack}
        tipoSnackBar={typesnackbar}
        mensaje={message}
        handleClosesSnack={handleClosesSnack}
      />
      <Formik
        initialValues={{
          EstatusContrato: "A",
          NumeroContrato: ""
        }}
        validationSchema={validationSchema}
        onSubmit={values => {
          const { NumeroContrato, EstatusContrato } = values;
          handleSearchContract(NumeroContrato, EstatusContrato);
        }}
      >
        {({ values, errors, touched }) => (
          <Form>
            <Grid container spacing={2} className={classes.formContainer}>
              <Grid item xs={12} sm={6}>
                <CustomSelect
                  label="Estatus de contrato"
                  name="EstatusContrato"
                >
                  <MenuItem key="0" value="0">
                    Seleccione...
                  </MenuItem>
                  <MenuItem key="1" value="P">
                    Pendiente
                  </MenuItem>
                  <MenuItem key="2" value="A">
                    Apartado
                  </MenuItem>
                  <MenuItem key="3" value="C">
                    Crédito activo
                  </MenuItem>
                  <MenuItem key="4" value="L">
                    Liquidado
                  </MenuItem>
                  <MenuItem key="5" value="M">
                    Moratorio
                  </MenuItem>
                  <MenuItem key="6" value="to">
                    Todos los estatus
                  </MenuItem>
                </CustomSelect>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInputForm
                  labelText="Número de contrato"
                  name="NumeroContrato"
                  formcontrolprops={{
                    fullWidth: true
                  }}
                  error={errors.NumeroContrato && touched.NumeroContrato}
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" color="success">
                  Buscar contratos
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <div className={classes.tableContainer}>
        <MaterialTable
          title="Lista de contratos"
          columns={column}
          data={contracts}
        />
      </div>
    </>
  );
}
